module.exports = __webpack_public_path__ + "static/media/big-check.83d4ff75.svg";